import { render, staticRenderFns } from "./ReferenceForm.vue?vue&type=template&id=660b5718&"
import script from "./ReferenceForm.vue?vue&type=script&lang=js&"
export * from "./ReferenceForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReferenceForm.vue"
export default component.exports